import { getFormLableStyleStr } from "../FormText/FormBaseStyle";
import { getPaddingString, formFieldErrorHtml, toRGBA } from "../parser/utils";

export default ({ data, id, root }) => {
  const {
    label,
    required,
    hideLabel,
    placeholder,
    options,
  } = data;

  const {
    formBorderWidth,
    formBorderStyle,
    formBorderColor,
    formBorderRadius,
    formTextColor,
  } = root.data;

  const labelStyle = getFormLableStyleStr(data, root.data);
  return `
    <div class="rip-field-group" style="text-align: left;${getPaddingString(
      data
    )}">
        <label
            for="${id}"
            class="rip-field-label"
                  style="${labelStyle}; display: ${
        hideLabel ? "none" : "flex"
      };"
    "
          >
            ${
              required
                ? '<span style="color: #ff4d4f; margin-right: 4px;">*</span>'
                : ""
            }${label}
        </label>
      <select
        style="
          height: 38px;
          padding: 0 8px;
          width: 100%;
          border-width: ${formBorderWidth}px;
          border-style: ${formBorderStyle};
          border-color: ${toRGBA(formBorderColor)};
          border-radius: ${formBorderRadius}px;
          color: ${toRGBA(formTextColor)};
        "
        class="rip-form-input"
        placeholder="${placeholder}"
        name="${id}"
        id="${id}"
      >
        <option style="color: #ccc;" value="">
          ${placeholder}
        </option>
        ${options
          .map((opt) => {
            return `
            <option value="${opt.label}">
              ${opt.label}
            </option>
            `;
          })
          .join("")}
      </select>
      ${formFieldErrorHtml({ id })}
    </div>
  `;
};
